/* Excel Downloads - This line cannot be edited or removed */
export const GET_EXCEL_DOWNLOAD_SALE = "GET_EXCEL_DOWNLOAD_SALE"
export const GET_EXCEL_DOWNLOAD_SALE_SUCCESS = "GET_EXCEL_DOWNLOAD_SALE_SUCCESS"
export const GET_EXCEL_DOWNLOAD_SALE_FAIL = "GET_EXCEL_DOWNLOAD_SALE_FAIL"

/* Excel Download_DETAILS */
export const GET_EXCEL_DOWNLOAD_VEHICLE = "GET_EXCEL_DOWNLOAD_VEHICLE"
export const GET_EXCEL_DOWNLOAD_VEHICLE_SUCCESS =
  "GET_EXCEL_DOWNLOAD_VEHICLE_SUCCESS"
export const GET_EXCEL_DOWNLOAD_VEHICLE_FAIL = "GET_EXCEL_DOWNLOAD_VEHICLE_FAIL"

export const GET_EXCEL_DOWNLOAD_LEAD = "GET_EXCEL_DOWNLOAD_LEAD"
export const GET_EXCEL_DOWNLOAD_LEAD_SUCCESS = "GET_EXCEL_DOWNLOAD_LEAD_SUCCESS"
export const GET_EXCEL_DOWNLOAD_LEAD_FAIL = "GET_EXCEL_DOWNLOAD_LEAD_FAIL"

export const GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD = "GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD"
export const GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_SUCCESS = "GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_SUCCESS"
export const GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_FAIL = "GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_FAIL"

export const GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT =
  "GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT"
export const GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_SUCCESS =
  "GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_SUCCESS"
export const GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_FAIL =
  "GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_FAIL"

export const GET_EXCEL_DOWNLOAD_CHALLAN = "GET_EXCEL_DOWNLOAD_CHALLAN"
export const GET_EXCEL_DOWNLOAD_CHALLAN_SUCCESS =
  "GET_EXCEL_DOWNLOAD_CHALLAN_SUCCESS"
export const GET_EXCEL_DOWNLOAD_CHALLAN_FAIL = "GET_EXCEL_DOWNLOAD_CHALLAN_FAIL"

export const GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING =
  "GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING"
export const GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_SUCCESS =
  "GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_SUCCESS"
export const GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_FAIL =
  "GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_FAIL"
